<template>
    <v-sheet border rounded width="100%" :max-width="wide ? undefined : 185" height="50"
        class="d-flex flex-row">
        <v-btn :color="text_color" class="my-auto" icon variant="text" @click="yesterday">
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-menu v-model="dialog" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ props }">
                <v-btn :loading="loading" :color="text_color" variant="text" :width="wide ? undefined : 110"
                    :class="wide ? 'my-auto flex-grow-1 pit-mono' : 'my-auto px-2 pit-mono'" style="min-width: 0" v-bind="props">
                    {{ date }}
                </v-btn>
            </template>
            <!-- JJEJEJEJEJEJJE -->
            <!-- WE USE THIS PARSING ISO DATESTRINGS -->
            <v-card>
                <v-card-text>
                    <v-switch :label="t('show_delayed_constructibles')"
                        :model-value="selected_store.show_delayed_constructibles"
                        @click="selected_store.toggleShowDelayedConstructibles">
                    </v-switch>
                    <v-switch :label="t('max_number_of_constructibles')"
                        :model-value="selected_store.max_shown_is_set" @click="selected_store.toggleMaxShownIsSet">
                    </v-switch>
                    <v-slider step="1" thumb-label min="5" max="50" color="accent" v-if="selected_store.max_shown_is_set"
                        :model-value="selected_store.max_shown_constructibles"
                        @end="selected_store.setMaxShownConstructibles"></v-slider>
                </v-card-text>
            </v-card>
            <v-date-picker no-title :model-value="adaptedDate" width="360" @update:model-value="touchDate" show-week>
                <v-spacer></v-spacer>
            </v-date-picker>
        </v-menu>
        <v-btn :color="text_color" class="my-auto" icon variant="text" @click="tomorrow">
            <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
    </v-sheet>
</template>

<style>
/* Setting padding to 0 prevents hiding last week of the month on mobile devices */
div.v-date-picker-table>table>tbody>tr>td {
    padding: 0 !important;
}
</style>

<script>
import { today } from '/src/utils/time'
import { useSelectedStore } from "@/stores/selected";
import { usePitStoreBasics } from "@/stores/app_common";
import { useDate } from 'vuetify'

// The date the store starts on, meaning "nobody has picked one yet".
const UNSET_DATE = "2000-01-01"

export default {
    setup() {
        const selected_store = useSelectedStore()
        return {
            ...usePitStoreBasics(),
            selected_store,
        }
    },
    props: ["wide"],
    data: () => ({
        dialog: false,
        loading: false,
        date_adapter: useDate(),
    }),
    computed: {
        is_today() {
            return this.date == today()
        },
        text_color() {
            if (this.is_today) {
                return "grey"
            } else {
                return "error"
            }
        },
        date() {
            return this.selected_store.selected_date
        },
        adaptedDate() {
            return this.date_adapter.parseISO(this.date)
        },
    },
    // watch: {
    //     date(d) {
    //         this.dialog = false
    //     },
    // },
    methods: {
        touchDate(new_date) {
            const datestring = this.date_adapter.toISO(new_date)
            this.setDate(datestring)
            this.dialog = false
        },
        setDate(d) {
            this.selected_store.setDate(d)
        },
        tomorrow() {
            const date_object = new Date(this.date)
            date_object.setHours(10)
            date_object.setDate(date_object.getDate() + 1)
            this.setDate(date_object.toISOString().slice(0, 10))
        },
        yesterday() {
            const date_object = new Date(this.date)
            date_object.setHours(10)
            date_object.setDate(date_object.getDate() - 1)
            this.setDate(date_object.toISOString().slice(0, 10))
        }
    },
    mounted() {
        // Only to fill the initial sentinel. The component remounts on every
        // entry into viewer mode, and resetting unconditionally threw away the
        // date the user had picked before stepping into the manager views.
        if (this.date == UNSET_DATE) this.setDate(today())
    }
}
</script>